<template>
<div>
    
        <v-data-table
        v-if="showdata == 'CUSTOMER CASH SALES'"
        :headers="headers"
        dense
        class="va-table"
        :items="summaries"
        :items-per-page="10000"
        hide-default-footer
        >
         <template v-slot:body="{ items }">
            <tbody>
                <tr v-for="(item,index) in items" :key="index">          
                     <td class="text-xs-left">
                             {{ item.customer_name }}
                         </td>
                          <td class="text-right">{{ $money(item.kilos) }}</td>
                         <td class="text-right">{{ $money(item.total) }}</td>
                         <td class="text-right">{{ $money(item.service_charge) }}</td>
                         <td class="text-right">{{ $money(item.trucking_fee) }}</td>
                         <td class="text-right">{{ $money($IsNum(item.total) + $IsNum(item.service_charge) + $IsNum(item.trucking_fee)) }}</td>
                </tr>
            </tbody>
               <tfoot >
                <tr class="font-weight-bold" >          
                    <td class="text-right" style="border-top: 1px solid #212121;">TOTAL</td>
                     <td class="text-right" style="border-top: 1px solid #212121;">{{ $money(TOTALKILOS) }}</td>
                    <td class="text-right" style="border-top: 1px solid #212121;">{{ $money(CASH) }}</td>
                    <td class="text-right" style="border-top: 1px solid #212121;">{{ $money(SERVICE_CHARGE) }}</td>
                    <td class="text-right" style="border-top: 1px solid #212121;">{{ $money(TRUCKING) }}</td>
                    <td class="text-right" style="border-top: 1px solid #212121;">{{ $money(TOTAL) }}</td>
                </tr>
                
            </tfoot>
        </template>
        </v-data-table>
</div>
</template>

<script>
export default {
  props: {
    show: {
        type: Boolean,
        default: false
    },
    selected_date: {
        type: String,
        default: ''
    },
    showdata: {
        type: String,
        default:'CUSTOMER CASH SALES'
    }
  },
   data: () => ({
      summaries: [],
      headers: [
            { text: 'Customer'},
              { text: 'Kilos', align:"right" , sortable: false},
            { text: 'Amount', align:"right" , sortable: false},
            { text: 'Service Charge', align:"right" , sortable: false},
            { text: 'Trucking', align:"right" , sortable: false},
            { text: 'Total', align:"right" , sortable: false}
      ]
  }),
  created(){
       this.getItems()
  },
  computed:{
    CASH(){
           var arr = this.summaries
           let total = arr.reduce((a, o) => a += this.$IsNum(o.total), 0)
           return total
      },
      TRUCKING(){
           var arr = this.summaries
           let total = arr.reduce((a, o) => a += this.$IsNum(o.trucking_fee), 0)
           return total
      },
      TOTALKILOS(){
           var arr = this.summaries
           let total = arr.reduce((a, o) => a += this.$IsNum(o.kilos), 0)
           return total
      },
      SERVICE_CHARGE(){
           var arr = this.summaries
           let total = arr.reduce((a, o) => a += this.$IsNum(o.service_charge), 0)
           return total
      },
      TOTAL(){
             return this.SERVICE_CHARGE + this.TRUCKING + this.CASH
      },
  },
  methods: {
       getItems: function() {
         this.summaries = []
            this.$http.post("summary/get_cash_bydate", JSON.stringify({log_date: this.selected_date})).then(response => {
                  response.data.data != null?this.summaries = response.data.data: this.summaries = []
          }).catch(e => {
           console.log(e.data)
         })
      },
  }
}
</script>
